export default __webpack_public_path__ + "static/media/calendar.b554e517.svg";